<template>
	<div id="app">
		<HeaderBar />

		<div class="content">
			<p>Website under development, please excuse ugly style and broken/missing features as well as missing legal things.</p>
			<router-view/>
		</div>
	</div>
</template>

<script>
	import HeaderBar from './components/HeaderBar.vue'

	export default {
		data () {
			return {
				menu_entries: {
					'Startpage': '/',
					'Applications': '/applications',
					'Development Blog': '/devblog',
				},
			}
		},

		computed: {
			user() {
				return this.$store.state.user
			},
		},

		methods: {
			logout() {
				this.core.logout()
			}
		},

		components: {
			HeaderBar
		},
	}
</script>

<style>
	body {
		font-family: sans-serif;
		background-color: #111;
		color: #aaa;
		margin: 0;
		-webkit-tap-highlight-color: #f0f0;
	}

	body a:link {
		color: #ddd;
	}

	body a:visited {
		/color: #666;
		color: #ddd;
	}
</style>

<style scoped>
	.content {
		margin-left: 8px;
		margin-right: 8px;
		margin-bottom: 8px;
	}
</style>